import PriceFormat from '@website/components/utilities/PriceFormat';
import { UserDashboardQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { Accordion } from 'react-bootstrap';
import CreditHistoryTable from './CreditsHistory';

type Props = {
  credits: UserDashboardQuery['user']['credits'];
};

export default function CustomerCreditHistory({ credits }: Props) {
  const creditsAltered = useMemo(() => {
    const cutOfDate = DateTime.fromISO('2025-02-15T00:00:00.000Z');

    return credits.map((credit) => ({
      ...credit,
      history: {
        ...credit.history,
        items: [
          ...credit.history.items.filter((item) => {
            // return only items created after today
            return DateTime.fromISO(item.created) > cutOfDate;
          }),
          ...[
            credit.history.items
              .filter((item) => {
                return DateTime.fromISO(item.created) <= cutOfDate;
              })
              .reduce(
                (acc, item) => {
                  acc.amountZD += item.amountZD;
                  return acc;
                },
                {
                  amountZD: 0,
                  created: cutOfDate.toISO(),
                  currency: credit.currency,
                  id: 'cut-off',
                  runningTotal: 0,
                  note: `Credit balance as of ${cutOfDate.toFormat('dd/MM/yyyy')}`,
                } as UserDashboardQuery['user']['credits'][number]['history']['items'][number],
              ),
          ],
        ],
      },
    }));
  }, [credits]);

  return (
    <>
      <h5 className="mt-4">User Credit History</h5>
      {creditsAltered.length > 0 ? (
        <Accordion defaultActiveKey={credits[0].currency}>
          {creditsAltered.map((credit) => (
            <Accordion.Item eventKey={credit.currency} key={credit.currency}>
              <Accordion.Header>
                {credit.currency} (Current Balance:{' '}
                <span className="ps-2">
                  <PriceFormat
                    amount={credit.amountZD}
                    currencyIso={credit.currency}
                  />
                </span>
                )
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <CreditHistoryTable creditHistory={credit.history.items} />
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      ) : (
        <p>No credit history</p>
      )}
    </>
  );
}
